import { camelcaseKeys } from 'src/utils/camelize-keys';
import { decamelizeKeys } from 'src/utils/decamelize-keys';
import { removeReadOnlyFields } from 'src/utils/fieldNormalizers';

import { AssignedVideo, Video } from './_types';

export const normalizeAssignedVideo = (resource): AssignedVideo => {
  return camelcaseKeys(resource, { deep: true }) as AssignedVideo;
};

export const normalizeVideo = (resource): Video => {
  return camelcaseKeys(resource, { deep: true }) as Video;
};

export const denormalizeGroupVideo = (resource): any => {
  const video = decamelizeKeys(resource, { deep: true });

  removeReadOnlyFields(video, ['tags', 'embed_url', 'thumbnail_id']);

  return video;
};

export const denormalizeVideo = (resource): any => {
  return decamelizeKeys(resource, { deep: true });
};
